/**
 * Markup for remote collaborator carets.
 *
 * Tiptap's CollaborationCaret defaults to `collaboration-carets__*` classes,
 * which no stylesheet here targets — the caret disappears and the selection
 * renders as an unstyled full-width bar. These emit the `yjs-cursor*` markup
 * that globals.css designs against, and are shared so the editor and the
 * read-only viewer cannot drift apart again.
 */

export interface CaretUser {
  name?: string;
  color?: string;
}

export function caretRender(user: CaretUser): HTMLElement {
  const cursor = document.createElement('span');
  cursor.classList.add('yjs-cursor');
  cursor.setAttribute('style', `border-color: ${user.color ?? 'currentColor'}`);

  const name = document.createElement('div');
  name.classList.add('yjs-cursor-name');
  name.setAttribute('style', `background-color: ${user.color ?? 'currentColor'}`);
  name.insertBefore(document.createTextNode(user.name ?? 'Anonymous'), null);

  cursor.insertBefore(name, null);
  return cursor;
}

export function caretSelectionRender(user: CaretUser): Record<string, string> {
  return {
    class: 'yjs-cursor-selection',
    style: `background-color: ${user.color ?? 'currentColor'}`,
    'data-user': user.name ?? 'Anonymous',
  };
}
